import { render, staticRenderFns } from "./Myformal.vue?vue&type=template&id=473423b8&scoped=true"
import script from "./Myformal.vue?vue&type=script&lang=js"
export * from "./Myformal.vue?vue&type=script&lang=js"
import style0 from "./Myformal.vue?vue&type=style&index=0&id=473423b8&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473423b8",
  null
  
)

export default component.exports